// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Jr3n","type":"styles_type__3a87c","choices":"styles_choices__RzRE-"};